import { ColumnType, BoardType } from './type'
import { Column } from './components/Column/Column'
import { BoardProvider } from './data/BoardProvider'
import { ColumnList, BoardContainer } from './style'

interface BoardProps {
  data: BoardType
  setData: React.Dispatch<React.SetStateAction<BoardType>>
  onTrash?: ((id: string) => void) | false
  investCard: boolean
  handleClick?: (..._param: any) => void
  onDropCard?: (..._param: any) => void
  noSpecialist?: boolean
  notDraggable?: boolean
  isEnterprise?: boolean
  columnsWithTrash?: number[]
  height?: string
  showDataPicker?: boolean
}

export default function Board({
  data,
  setData,
  onTrash,
  investCard,
  handleClick,
  onDropCard,
  noSpecialist,
  notDraggable,
  isEnterprise,
  columnsWithTrash,
  height,
  showDataPicker,
}: BoardProps) {
  const sortedData = data.map((col: ColumnType) => ({
    ...col,
    cardList: [...col.cardList].sort(
      (a: any, b: any) =>
        new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime()
    ),
  })) // Sort para ordenar os cards por data de atualização (do mais recente para o mais antigo)

  return (
    <BoardProvider data={sortedData} setData={setData} onDropCard={onDropCard}>
      <BoardContainer className="board" showDataPicker={showDataPicker}>
        <ColumnList className="column-list">
          {sortedData.map((col: ColumnType) => (
            <Column
              notDraggable={notDraggable}
              handleClick={handleClick}
              key={col.id}
              column={col}
              height={height}
              isEnterprise={isEnterprise}
              noSpecialist={noSpecialist}
              onTrash={onTrash}
              columnsWithTrash={columnsWithTrash}
              investCard={investCard}
            />
          ))}
        </ColumnList>
      </BoardContainer>
    </BoardProvider>
  )
}
